// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const VERCEL_AI_GATEWAY_MODELS = {
	"alibaba/qwen-3-14b": {
		id: "alibaba/qwen-3-14b",
		name: "Qwen3-14B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.12,
			output: 0.24,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 40960,
		maxTokens: 16384,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen-3-235b": {
		id: "alibaba/qwen-3-235b",
		name: "Qwen3 235B A22B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.22,
			output: 0.88,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 16384,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen-3-30b": {
		id: "alibaba/qwen-3-30b",
		name: "Qwen3-30B-A3B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.12,
			output: 0.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 40960,
		maxTokens: 16384,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen-3-32b": {
		id: "alibaba/qwen-3-32b",
		name: "Qwen 3 32B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.16,
			output: 0.64,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen-3.6-max-preview": {
		id: "alibaba/qwen-3.6-max-preview",
		name: "Qwen 3.6 Max Preview",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.3,
			output: 7.8,
			cacheRead: 0.26,
			cacheWrite: 1.625,
		},
		contextWindow: 240000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-235b-a22b-thinking": {
		id: "alibaba/qwen3-235b-a22b-thinking",
		name: "Qwen3 VL 235B A22B Thinking",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.4,
			output: 4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-coder": {
		id: "alibaba/qwen3-coder",
		name: "Qwen3 Coder 480B A35B Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 1.5,
			output: 7.5,
			cacheRead: 0.3,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-coder-30b-a3b": {
		id: "alibaba/qwen3-coder-30b-a3b",
		name: "Qwen 3 Coder 30B A3B Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-coder-next": {
		id: "alibaba/qwen3-coder-next",
		name: "Qwen3 Coder Next",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.5,
			output: 1.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-coder-plus": {
		id: "alibaba/qwen3-coder-plus",
		name: "Qwen3 Coder Plus",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 1,
			output: 5,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 65536,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-max": {
		id: "alibaba/qwen3-max",
		name: "Qwen3 Max",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 1.2,
			output: 6,
			cacheRead: 0.24,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-max-preview": {
		id: "alibaba/qwen3-max-preview",
		name: "Qwen3 Max Preview",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 1.2,
			output: 6,
			cacheRead: 0.24,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-max-thinking": {
		id: "alibaba/qwen3-max-thinking",
		name: "Qwen 3 Max Thinking",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.2,
			output: 6,
			cacheRead: 0.24,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 65536,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-next-80b-a3b-instruct": {
		id: "alibaba/qwen3-next-80b-a3b-instruct",
		name: "Qwen3 Next 80B A3B Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 1.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-next-80b-a3b-thinking": {
		id: "alibaba/qwen3-next-80b-a3b-thinking",
		name: "Qwen3 Next 80B A3B Thinking",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 1.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-vl-235b-a22b-instruct": {
		id: "alibaba/qwen3-vl-235b-a22b-instruct",
		name: "Qwen3 VL 235B A22B Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.4,
			output: 1.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 129024,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-vl-instruct": {
		id: "alibaba/qwen3-vl-instruct",
		name: "Qwen3 VL 235B A22B Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.4,
			output: 1.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 129024,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3-vl-thinking": {
		id: "alibaba/qwen3-vl-thinking",
		name: "Qwen3 VL 235B A22B Thinking",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.4,
			output: 4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3.5-flash": {
		id: "alibaba/qwen3.5-flash",
		name: "Qwen 3.5 Flash",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.1,
			output: 0.4,
			cacheRead: 0.001,
			cacheWrite: 0.125,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3.5-plus": {
		id: "alibaba/qwen3.5-plus",
		name: "Qwen 3.5 Plus",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.4,
			output: 2.4,
			cacheRead: 0.04,
			cacheWrite: 0.5,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3.6-27b": {
		id: "alibaba/qwen3.6-27b",
		name: "Qwen 3.6 27B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.6,
			output: 3.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3.6-plus": {
		id: "alibaba/qwen3.6-plus",
		name: "Qwen 3.6 Plus",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.5,
			output: 3,
			cacheRead: 0.1,
			cacheWrite: 0.625,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3.7-max": {
		id: "alibaba/qwen3.7-max",
		name: "Qwen 3.7 Max",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.25,
			output: 3.75,
			cacheRead: 0.25,
			cacheWrite: 1.5625,
		},
		contextWindow: 991000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"alibaba/qwen3.7-plus": {
		id: "alibaba/qwen3.7-plus",
		name: "Qwen 3.7 Plus",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.4,
			output: 1.6,
			cacheRead: 0.08,
			cacheWrite: 0.5,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"amazon/nova-2-lite": {
		id: "amazon/nova-2-lite",
		name: "Nova 2 Lite",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.3,
			output: 2.5,
			cacheRead: 0.075,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 1000000,
	} satisfies Model<"anthropic-messages">,
	"amazon/nova-lite": {
		id: "amazon/nova-lite",
		name: "Nova Lite",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.06,
			output: 0.24,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 300000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"amazon/nova-micro": {
		id: "amazon/nova-micro",
		name: "Nova Micro",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.035,
			output: 0.14,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"amazon/nova-pro": {
		id: "amazon/nova-pro",
		name: "Nova Pro",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.8,
			output: 3.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 300000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-3-haiku": {
		id: "anthropic/claude-3-haiku",
		name: "Claude 3 Haiku",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 1.25,
			cacheRead: 0.03,
			cacheWrite: 0.3,
		},
		contextWindow: 200000,
		maxTokens: 4096,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-fable-5": {
		id: "anthropic/claude-fable-5",
		name: "Claude Fable 5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		compat: {"forceAdaptiveThinking":true},
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 10,
			output: 50,
			cacheRead: 1,
			cacheWrite: 12.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-haiku-4.5": {
		id: "anthropic/claude-haiku-4.5",
		name: "Claude Haiku 4.5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 5,
			cacheRead: 0.1,
			cacheWrite: 1.25,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-opus-4": {
		id: "anthropic/claude-opus-4",
		name: "Claude Opus 4",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 15,
			output: 75,
			cacheRead: 1.5,
			cacheWrite: 18.75,
		},
		contextWindow: 200000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-opus-4.1": {
		id: "anthropic/claude-opus-4.1",
		name: "Claude Opus 4.1",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 15,
			output: 75,
			cacheRead: 1.5,
			cacheWrite: 18.75,
		},
		contextWindow: 200000,
		maxTokens: 32000,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-opus-4.5": {
		id: "anthropic/claude-opus-4.5",
		name: "Claude Opus 4.5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-opus-4.6": {
		id: "anthropic/claude-opus-4.6",
		name: "Claude Opus 4.6",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		compat: {"forceAdaptiveThinking":true},
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-opus-4.7": {
		id: "anthropic/claude-opus-4.7",
		name: "Claude Opus 4.7",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		compat: {"forceAdaptiveThinking":true,"supportsTemperature":false},
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-opus-4.7-fast": {
		id: "anthropic/claude-opus-4.7-fast",
		name: "Claude Opus 4.7 (Fast)",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		compat: {"forceAdaptiveThinking":true,"supportsTemperature":false},
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 30,
			output: 150,
			cacheRead: 3,
			cacheWrite: 37.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-opus-4.8": {
		id: "anthropic/claude-opus-4.8",
		name: "Claude Opus 4.8",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		compat: {"forceAdaptiveThinking":true,"supportsTemperature":false},
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-opus-4.8-fast": {
		id: "anthropic/claude-opus-4.8-fast",
		name: "Claude Opus 4.8 (Fast)",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		compat: {"forceAdaptiveThinking":true,"supportsTemperature":false},
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 10,
			output: 50,
			cacheRead: 1,
			cacheWrite: 12.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-sonnet-4": {
		id: "anthropic/claude-sonnet-4",
		name: "Claude Sonnet 4",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 1000000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-sonnet-4.5": {
		id: "anthropic/claude-sonnet-4.5",
		name: "Claude Sonnet 4.5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-sonnet-4.6": {
		id: "anthropic/claude-sonnet-4.6",
		name: "Claude Sonnet 4.6",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		compat: {"forceAdaptiveThinking":true},
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"anthropic/claude-sonnet-5": {
		id: "anthropic/claude-sonnet-5",
		name: "Claude Sonnet 5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		compat: {"forceAdaptiveThinking":true},
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 10,
			cacheRead: 0.2,
			cacheWrite: 2.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"arcee-ai/trinity-large-thinking": {
		id: "arcee-ai/trinity-large-thinking",
		name: "Trinity Large Thinking",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.25,
			output: 0.9,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262100,
		maxTokens: 80000,
	} satisfies Model<"anthropic-messages">,
	"arcee-ai/trinity-mini": {
		id: "arcee-ai/trinity-mini",
		name: "Trinity Mini",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.045,
			output: 0.15,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"bytedance/seed-1.6": {
		id: "bytedance/seed-1.6",
		name: "Seed 1.6",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 2,
			cacheRead: 0.05,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 32000,
	} satisfies Model<"anthropic-messages">,
	"bytedance/seed-1.8": {
		id: "bytedance/seed-1.8",
		name: "Bytedance Seed 1.8",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 2,
			cacheRead: 0.05,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"cohere/command-a": {
		id: "cohere/command-a",
		name: "Command A",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 2.5,
			output: 10,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 8000,
	} satisfies Model<"anthropic-messages">,
	"deepseek/deepseek-r1": {
		id: "deepseek/deepseek-r1",
		name: "DeepSeek-R1",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.35,
			output: 5.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"deepseek/deepseek-v3": {
		id: "deepseek/deepseek-v3",
		name: "DeepSeek V3 0324",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.27,
			output: 1.12,
			cacheRead: 0.135,
			cacheWrite: 0,
		},
		contextWindow: 163840,
		maxTokens: 163840,
	} satisfies Model<"anthropic-messages">,
	"deepseek/deepseek-v3.1": {
		id: "deepseek/deepseek-v3.1",
		name: "DeepSeek V3.1",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.25,
			output: 0.95,
			cacheRead: 0.13,
			cacheWrite: 0,
		},
		contextWindow: 163840,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"deepseek/deepseek-v3.1-terminus": {
		id: "deepseek/deepseek-v3.1-terminus",
		name: "DeepSeek V3.1 Terminus",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.27,
			output: 1,
			cacheRead: 0.135,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 65536,
	} satisfies Model<"anthropic-messages">,
	"deepseek/deepseek-v3.2": {
		id: "deepseek/deepseek-v3.2",
		name: "DeepSeek V3.2",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.28,
			output: 0.42,
			cacheRead: 0.028,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8000,
	} satisfies Model<"anthropic-messages">,
	"deepseek/deepseek-v3.2-thinking": {
		id: "deepseek/deepseek-v3.2-thinking",
		name: "DeepSeek V3.2 Thinking",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.62,
			output: 1.85,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8000,
	} satisfies Model<"anthropic-messages">,
	"deepseek/deepseek-v4-flash": {
		id: "deepseek/deepseek-v4-flash",
		name: "DeepSeek V4 Flash",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.14,
			output: 0.28,
			cacheRead: 0.028,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 384000,
	} satisfies Model<"anthropic-messages">,
	"deepseek/deepseek-v4-pro": {
		id: "deepseek/deepseek-v4-pro",
		name: "DeepSeek V4 Pro",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.435,
			output: 0.87,
			cacheRead: 0.0036,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 384000,
	} satisfies Model<"anthropic-messages">,
	"google/gemini-2.5-flash": {
		id: "google/gemini-2.5-flash",
		name: "Gemini 2.5 Flash",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.3,
			output: 2.5,
			cacheRead: 0.03,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 65536,
	} satisfies Model<"anthropic-messages">,
	"google/gemini-2.5-flash-lite": {
		id: "google/gemini-2.5-flash-lite",
		name: "Gemini 2.5 Flash Lite",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.1,
			output: 0.4,
			cacheRead: 0.01,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"anthropic-messages">,
	"google/gemini-2.5-pro": {
		id: "google/gemini-2.5-pro",
		name: "Gemini 2.5 Pro",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"anthropic-messages">,
	"google/gemini-3-flash": {
		id: "google/gemini-3-flash",
		name: "Gemini 3 Flash",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.5,
			output: 3,
			cacheRead: 0.05,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 65000,
	} satisfies Model<"anthropic-messages">,
	"google/gemini-3-pro-preview": {
		id: "google/gemini-3-pro-preview",
		name: "Gemini 3 Pro Preview",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 12,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"google/gemini-3.1-flash-lite": {
		id: "google/gemini-3.1-flash-lite",
		name: "Gemini 3.1 Flash Lite",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 1.5,
			cacheRead: 0.03,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 65000,
	} satisfies Model<"anthropic-messages">,
	"google/gemini-3.1-flash-lite-preview": {
		id: "google/gemini-3.1-flash-lite-preview",
		name: "Gemini 3.1 Flash Lite Preview",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 1.5,
			cacheRead: 0.03,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 65000,
	} satisfies Model<"anthropic-messages">,
	"google/gemini-3.1-pro-preview": {
		id: "google/gemini-3.1-pro-preview",
		name: "Gemini 3.1 Pro Preview",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 12,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"google/gemini-3.5-flash": {
		id: "google/gemini-3.5-flash",
		name: "Gemini 3.5 Flash",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.5,
			output: 9,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"google/gemma-4-26b-a4b-it": {
		id: "google/gemma-4-26b-a4b-it",
		name: "Gemma 4 26B A4B IT",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0.015,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"google/gemma-4-31b-it": {
		id: "google/gemma-4-31b-it",
		name: "Gemma 4 31B IT",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.14,
			output: 0.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"inception/mercury-2": {
		id: "inception/mercury-2",
		name: "Mercury 2",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.25,
			output: 0.75,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"inception/mercury-coder-small": {
		id: "inception/mercury-coder-small",
		name: "Mercury Coder Small Beta",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.25,
			output: 1,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 32000,
		maxTokens: 16384,
	} satisfies Model<"anthropic-messages">,
	"interfaze/interfaze-beta": {
		id: "interfaze/interfaze-beta",
		name: "Interfaze Beta",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.5,
			output: 3.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 32000,
	} satisfies Model<"anthropic-messages">,
	"kwaipilot/kat-coder-air-v2.5": {
		id: "kwaipilot/kat-coder-air-v2.5",
		name: "Kat Coder Air V2.5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0.03,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 80000,
	} satisfies Model<"anthropic-messages">,
	"kwaipilot/kat-coder-pro-v1": {
		id: "kwaipilot/kat-coder-pro-v1",
		name: "KAT-Coder-Pro V1",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 32000,
	} satisfies Model<"anthropic-messages">,
	"kwaipilot/kat-coder-pro-v2": {
		id: "kwaipilot/kat-coder-pro-v2",
		name: "Kat Coder Pro V2",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"anthropic-messages">,
	"kwaipilot/kat-coder-pro-v2.5": {
		id: "kwaipilot/kat-coder-pro-v2.5",
		name: "Kat Coder Pro V2.5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.74,
			output: 2.96,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 80000,
	} satisfies Model<"anthropic-messages">,
	"meta/llama-3.1-70b": {
		id: "meta/llama-3.1-70b",
		name: "Llama 3.1 70B Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.72,
			output: 0.72,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"meta/llama-3.1-8b": {
		id: "meta/llama-3.1-8b",
		name: "Llama 3.1 8B Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.22,
			output: 0.22,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"meta/llama-3.2-11b": {
		id: "meta/llama-3.2-11b",
		name: "Llama 3.2 11B Vision Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.16,
			output: 0.16,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"meta/llama-3.2-90b": {
		id: "meta/llama-3.2-90b",
		name: "Llama 3.2 90B Vision Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.72,
			output: 0.72,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"meta/llama-3.3-70b": {
		id: "meta/llama-3.3-70b",
		name: "Llama 3.3 70B Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.72,
			output: 0.72,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"meta/llama-4-maverick": {
		id: "meta/llama-4-maverick",
		name: "Llama 4 Maverick 17B Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.24,
			output: 0.97,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"meta/llama-4-scout": {
		id: "meta/llama-4-scout",
		name: "Llama 4 Scout 17B Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.17,
			output: 0.66,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"meta/muse-spark-1.1": {
		id: "meta/muse-spark-1.1",
		name: "Muse Spark 1.1",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 4.25,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 1048576,
	} satisfies Model<"anthropic-messages">,
	"minimax/minimax-m2": {
		id: "minimax/minimax-m2",
		name: "MiniMax M2",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.03,
			cacheWrite: 0.375,
		},
		contextWindow: 205000,
		maxTokens: 205000,
	} satisfies Model<"anthropic-messages">,
	"minimax/minimax-m2.1": {
		id: "minimax/minimax-m2.1",
		name: "MiniMax M2.1",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.03,
			cacheWrite: 0.375,
		},
		contextWindow: 204800,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"minimax/minimax-m2.1-lightning": {
		id: "minimax/minimax-m2.1-lightning",
		name: "MiniMax M2.1 Lightning",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 2.4,
			cacheRead: 0.03,
			cacheWrite: 0.375,
		},
		contextWindow: 204800,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"minimax/minimax-m2.5": {
		id: "minimax/minimax-m2.5",
		name: "MiniMax M2.5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.03,
			cacheWrite: 0.375,
		},
		contextWindow: 204800,
		maxTokens: 131000,
	} satisfies Model<"anthropic-messages">,
	"minimax/minimax-m2.5-highspeed": {
		id: "minimax/minimax-m2.5-highspeed",
		name: "MiniMax M2.5 High Speed",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.4,
			cacheRead: 0.03,
			cacheWrite: 0.375,
		},
		contextWindow: 204800,
		maxTokens: 131000,
	} satisfies Model<"anthropic-messages">,
	"minimax/minimax-m2.7": {
		id: "minimax/minimax-m2.7",
		name: "MiniMax M2.7",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0.375,
		},
		contextWindow: 204800,
		maxTokens: 131000,
	} satisfies Model<"anthropic-messages">,
	"minimax/minimax-m2.7-highspeed": {
		id: "minimax/minimax-m2.7-highspeed",
		name: "MiniMax M2.7 High Speed",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.4,
			cacheRead: 0.06,
			cacheWrite: 0.375,
		},
		contextWindow: 204800,
		maxTokens: 131100,
	} satisfies Model<"anthropic-messages">,
	"minimax/minimax-m3": {
		id: "minimax/minimax-m3",
		name: "MiniMax M3",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 1000000,
	} satisfies Model<"anthropic-messages">,
	"mistral/codestral": {
		id: "mistral/codestral",
		name: "Mistral Codestral",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 0.9,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4000,
	} satisfies Model<"anthropic-messages">,
	"mistral/devstral-2": {
		id: "mistral/devstral-2",
		name: "Devstral 2",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.4,
			output: 2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"anthropic-messages">,
	"mistral/devstral-small-2": {
		id: "mistral/devstral-small-2",
		name: "Devstral Small 2",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.1,
			output: 0.3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"anthropic-messages">,
	"mistral/magistral-medium": {
		id: "mistral/magistral-medium",
		name: "Magistral Medium 2509",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"mistral/magistral-small": {
		id: "mistral/magistral-small",
		name: "Magistral Small 2509",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.5,
			output: 1.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"mistral/ministral-14b": {
		id: "mistral/ministral-14b",
		name: "Ministral 14B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.2,
			output: 0.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"anthropic-messages">,
	"mistral/ministral-3b": {
		id: "mistral/ministral-3b",
		name: "Ministral 3B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.1,
			output: 0.1,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4000,
	} satisfies Model<"anthropic-messages">,
	"mistral/ministral-8b": {
		id: "mistral/ministral-8b",
		name: "Ministral 8B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.15,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4000,
	} satisfies Model<"anthropic-messages">,
	"mistral/mistral-large-3": {
		id: "mistral/mistral-large-3",
		name: "Mistral Large 3",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.5,
			output: 1.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"anthropic-messages">,
	"mistral/mistral-medium": {
		id: "mistral/mistral-medium",
		name: "Mistral Medium 3.1",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.4,
			output: 2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"mistral/mistral-medium-3.5": {
		id: "mistral/mistral-medium-3.5",
		name: "Mistral Medium Latest",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.5,
			output: 7.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"anthropic-messages">,
	"mistral/mistral-nemo": {
		id: "mistral/mistral-nemo",
		name: "Mistral Nemo 12B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.15,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"mistral/mistral-small": {
		id: "mistral/mistral-small",
		name: "Mistral Small",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.1,
			output: 0.3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 32000,
		maxTokens: 4000,
	} satisfies Model<"anthropic-messages">,
	"mistral/pixtral-12b": {
		id: "mistral/pixtral-12b",
		name: "Pixtral 12B 2409",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.15,
			output: 0.15,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4000,
	} satisfies Model<"anthropic-messages">,
	"moonshotai/kimi-k2": {
		id: "moonshotai/kimi-k2",
		name: "Kimi K2 Instruct",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.57,
			output: 2.3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"moonshotai/kimi-k2-thinking": {
		id: "moonshotai/kimi-k2-thinking",
		name: "Kimi K2 Thinking",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.47,
			output: 2,
			cacheRead: 0.141,
			cacheWrite: 0,
		},
		contextWindow: 216144,
		maxTokens: 216144,
	} satisfies Model<"anthropic-messages">,
	"moonshotai/kimi-k2.5": {
		id: "moonshotai/kimi-k2.5",
		name: "Kimi K2.5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.6,
			output: 3,
			cacheRead: 0.1,
			cacheWrite: 0,
		},
		contextWindow: 262114,
		maxTokens: 262114,
	} satisfies Model<"anthropic-messages">,
	"moonshotai/kimi-k2.6": {
		id: "moonshotai/kimi-k2.6",
		name: "Kimi K2.6",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.16,
			cacheWrite: 0,
		},
		contextWindow: 262000,
		maxTokens: 262000,
	} satisfies Model<"anthropic-messages">,
	"moonshotai/kimi-k2.7-code": {
		id: "moonshotai/kimi-k2.7-code",
		name: "Kimi K2.7 Code",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.19,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"moonshotai/kimi-k2.7-code-highspeed": {
		id: "moonshotai/kimi-k2.7-code-highspeed",
		name: "Kimi K2.7 Code High Speed",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.9,
			output: 8,
			cacheRead: 0.38,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"moonshotai/kimi-k3": {
		id: "moonshotai/kimi-k3",
		name: "Kimi K3",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"nvidia/nemotron-3-nano-30b-a3b": {
		id: "nvidia/nemotron-3-nano-30b-a3b",
		name: "Nemotron 3 Nano 30B A3B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.05,
			output: 0.24,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"anthropic-messages">,
	"nvidia/nemotron-3-super-120b-a12b": {
		id: "nvidia/nemotron-3-super-120b-a12b",
		name: "NVIDIA Nemotron 3 Super 120B A12B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.65,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 32000,
	} satisfies Model<"anthropic-messages">,
	"nvidia/nemotron-3-ultra-550b-a55b": {
		id: "nvidia/nemotron-3-ultra-550b-a55b",
		name: "Nemotron 3 Ultra",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.4,
			cacheRead: 0.12,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 65000,
	} satisfies Model<"anthropic-messages">,
	"nvidia/nemotron-nano-12b-v2-vl": {
		id: "nvidia/nemotron-nano-12b-v2-vl",
		name: "Nvidia Nemotron Nano 12B V2 VL",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.2,
			output: 0.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"nvidia/nemotron-nano-9b-v2": {
		id: "nvidia/nemotron-nano-9b-v2",
		name: "Nvidia Nemotron Nano 9B V2",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.06,
			output: 0.23,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-3.5-turbo": {
		id: "openai/gpt-3.5-turbo",
		name: "GPT-3.5 Turbo",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.5,
			output: 1.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 16385,
		maxTokens: 4096,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-4-turbo": {
		id: "openai/gpt-4-turbo",
		name: "GPT-4 Turbo",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 10,
			output: 30,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-4.1": {
		id: "openai/gpt-4.1",
		name: "GPT-4.1",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 8,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 1047576,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-4.1-mini": {
		id: "openai/gpt-4.1-mini",
		name: "GPT-4.1 mini",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.4,
			output: 1.6,
			cacheRead: 0.1,
			cacheWrite: 0,
		},
		contextWindow: 1047576,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-4.1-nano": {
		id: "openai/gpt-4.1-nano",
		name: "GPT-4.1 nano",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.1,
			output: 0.4,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 1047576,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-4o": {
		id: "openai/gpt-4o",
		name: "GPT-4o",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 2.5,
			output: 10,
			cacheRead: 1.25,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-4o-mini": {
		id: "openai/gpt-4o-mini",
		name: "GPT-4o mini",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0.075,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5": {
		id: "openai/gpt-5",
		name: "GPT-5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5-chat": {
		id: "openai/gpt-5-chat",
		name: "GPT 5 Chat",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5-codex": {
		id: "openai/gpt-5-codex",
		name: "GPT-5-Codex",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5-mini": {
		id: "openai/gpt-5-mini",
		name: "GPT-5 mini",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 2,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5-nano": {
		id: "openai/gpt-5-nano",
		name: "GPT-5 nano",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.05,
			output: 0.4,
			cacheRead: 0.005,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5-pro": {
		id: "openai/gpt-5-pro",
		name: "GPT-5 pro",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 15,
			output: 120,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 272000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.1-codex": {
		id: "openai/gpt-5.1-codex",
		name: "GPT-5.1-Codex",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.1-codex-max": {
		id: "openai/gpt-5.1-codex-max",
		name: "GPT 5.1 Codex Max",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.1-codex-mini": {
		id: "openai/gpt-5.1-codex-mini",
		name: "GPT 5.1 Codex Mini",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 2,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.1-instant": {
		id: "openai/gpt-5.1-instant",
		name: "GPT-5.1 Instant",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.1-thinking": {
		id: "openai/gpt-5.1-thinking",
		name: "GPT 5.1 Thinking",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.2": {
		id: "openai/gpt-5.2",
		name: "GPT 5.2",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.2-chat": {
		id: "openai/gpt-5.2-chat",
		name: "GPT 5.2 Chat",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.2-codex": {
		id: "openai/gpt-5.2-codex",
		name: "GPT 5.2 Codex",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.2-pro": {
		id: "openai/gpt-5.2-pro",
		name: "GPT 5.2 ",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 21,
			output: 168,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.3-chat": {
		id: "openai/gpt-5.3-chat",
		name: "GPT-5.3 Chat",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.3-codex": {
		id: "openai/gpt-5.3-codex",
		name: "GPT 5.3 Codex",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.4": {
		id: "openai/gpt-5.4",
		name: "GPT 5.4",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 2.5,
			output: 15,
			cacheRead: 0.25,
			cacheWrite: 0,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.4-mini": {
		id: "openai/gpt-5.4-mini",
		name: "GPT 5.4 Mini",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 0.75,
			output: 4.5,
			cacheRead: 0.075,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.4-nano": {
		id: "openai/gpt-5.4-nano",
		name: "GPT 5.4 Nano",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 0.2,
			output: 1.25,
			cacheRead: 0.02,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.4-pro": {
		id: "openai/gpt-5.4-pro",
		name: "GPT 5.4 Pro",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 30,
			output: 180,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.5": {
		id: "openai/gpt-5.5",
		name: "GPT 5.5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 30,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.5-pro": {
		id: "openai/gpt-5.5-pro",
		name: "GPT 5.5 Pro",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","off":null,"minimal":null,"low":null},
		input: ["text", "image"],
		cost: {
			input: 30,
			output: 180,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.6-luna": {
		id: "openai/gpt-5.6-luna",
		name: "GPT 5.6 Luna",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 6,
			cacheRead: 0.1,
			cacheWrite: 1.25,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.6-sol": {
		id: "openai/gpt-5.6-sol",
		name: "GPT 5.6 Sol",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 30,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-5.6-terra": {
		id: "openai/gpt-5.6-terra",
		name: "GPT 5.6 Terra",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 2.5,
			output: 15,
			cacheRead: 0.25,
			cacheWrite: 3.125,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-oss-120b": {
		id: "openai/gpt-oss-120b",
		name: "GPT OSS 120B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.1,
			output: 0.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-oss-20b": {
		id: "openai/gpt-oss-20b",
		name: "GPT OSS 20B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.05,
			output: 0.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 8192,
	} satisfies Model<"anthropic-messages">,
	"openai/gpt-oss-safeguard-20b": {
		id: "openai/gpt-oss-safeguard-20b",
		name: "GPT OSS Safeguard 20B",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.075,
			output: 0.3,
			cacheRead: 0.037,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 65536,
	} satisfies Model<"anthropic-messages">,
	"openai/o1": {
		id: "openai/o1",
		name: "o1",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 15,
			output: 60,
			cacheRead: 7.5,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"anthropic-messages">,
	"openai/o3": {
		id: "openai/o3",
		name: "o3",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 8,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"anthropic-messages">,
	"openai/o3-deep-research": {
		id: "openai/o3-deep-research",
		name: "o3-deep-research",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 10,
			output: 40,
			cacheRead: 2.5,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"anthropic-messages">,
	"openai/o3-mini": {
		id: "openai/o3-mini",
		name: "o3-mini",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.1,
			output: 4.4,
			cacheRead: 0.55,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"anthropic-messages">,
	"openai/o3-pro": {
		id: "openai/o3-pro",
		name: "o3 Pro",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 20,
			output: 80,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"anthropic-messages">,
	"openai/o4-mini": {
		id: "openai/o4-mini",
		name: "o4-mini",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.1,
			output: 4.4,
			cacheRead: 0.275,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"anthropic-messages">,
	"sakana/fugu-ultra": {
		id: "sakana/fugu-ultra",
		name: "Fugu Ultra",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 30,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 1000000,
	} satisfies Model<"anthropic-messages">,
	"stepfun/step-3.5-flash": {
		id: "stepfun/step-3.5-flash",
		name: "StepFun 3.5 Flash",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.09,
			output: 0.3,
			cacheRead: 0.02,
			cacheWrite: 0,
		},
		contextWindow: 262114,
		maxTokens: 262114,
	} satisfies Model<"anthropic-messages">,
	"stepfun/step-3.7-flash": {
		id: "stepfun/step-3.7-flash",
		name: "Step 3.7 Flash",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.2,
			output: 1.15,
			cacheRead: 0.04,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"anthropic-messages">,
	"thinkingmachines/inkling": {
		id: "thinkingmachines/inkling",
		name: "Inkling",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 4.05,
			cacheRead: 0.17,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"anthropic-messages">,
	"xai/grok-4.1-fast-non-reasoning": {
		id: "xai/grok-4.1-fast-non-reasoning",
		name: "Grok 4.1 Fast Non-Reasoning",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.2,
			output: 0.5,
			cacheRead: 0.05,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 1000000,
	} satisfies Model<"anthropic-messages">,
	"xai/grok-4.1-fast-reasoning": {
		id: "xai/grok-4.1-fast-reasoning",
		name: "Grok 4.1 Fast Reasoning",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.2,
			output: 0.5,
			cacheRead: 0.05,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 1000000,
	} satisfies Model<"anthropic-messages">,
	"xai/grok-4.20-multi-agent": {
		id: "xai/grok-4.20-multi-agent",
		name: "Grok 4.20 Multi-Agent",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 2.5,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 2000000,
		maxTokens: 2000000,
	} satisfies Model<"anthropic-messages">,
	"xai/grok-4.20-multi-agent-beta": {
		id: "xai/grok-4.20-multi-agent-beta",
		name: "Grok 4.20 Multi Agent Beta",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 2.5,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 2000000,
		maxTokens: 2000000,
	} satisfies Model<"anthropic-messages">,
	"xai/grok-4.20-non-reasoning": {
		id: "xai/grok-4.20-non-reasoning",
		name: "Grok 4.20 Non-Reasoning",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 2.5,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 2000000,
		maxTokens: 2000000,
	} satisfies Model<"anthropic-messages">,
	"xai/grok-4.20-non-reasoning-beta": {
		id: "xai/grok-4.20-non-reasoning-beta",
		name: "Grok 4.20 Beta Non-Reasoning",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 2.5,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 2000000,
		maxTokens: 2000000,
	} satisfies Model<"anthropic-messages">,
	"xai/grok-4.20-reasoning": {
		id: "xai/grok-4.20-reasoning",
		name: "Grok 4.20 Reasoning",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 2.5,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 2000000,
		maxTokens: 2000000,
	} satisfies Model<"anthropic-messages">,
	"xai/grok-4.20-reasoning-beta": {
		id: "xai/grok-4.20-reasoning-beta",
		name: "Grok 4.20 Beta Reasoning",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 2.5,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 2000000,
		maxTokens: 2000000,
	} satisfies Model<"anthropic-messages">,
	"xai/grok-4.3": {
		id: "xai/grok-4.3",
		name: "Grok 4.3",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 2.5,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 1000000,
	} satisfies Model<"anthropic-messages">,
	"xai/grok-4.5": {
		id: "xai/grok-4.5",
		name: "Grok 4.5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 6,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 500000,
		maxTokens: 500000,
	} satisfies Model<"anthropic-messages">,
	"xai/grok-build-0.1": {
		id: "xai/grok-build-0.1",
		name: "Grok Build 0.1",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 2,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 256000,
	} satisfies Model<"anthropic-messages">,
	"xiaomi/mimo-v2.5": {
		id: "xiaomi/mimo-v2.5",
		name: "MiMo M2.5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.14,
			output: 0.28,
			cacheRead: 0.0028,
			cacheWrite: 0,
		},
		contextWindow: 1050000,
		maxTokens: 131100,
	} satisfies Model<"anthropic-messages">,
	"xiaomi/mimo-v2.5-pro": {
		id: "xiaomi/mimo-v2.5-pro",
		name: "MiMo V2.5 Pro",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.435,
			output: 0.87,
			cacheRead: 0.0036,
			cacheWrite: 0,
		},
		contextWindow: 1050000,
		maxTokens: 131000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-4.5": {
		id: "zai/glm-4.5",
		name: "GLM 4.5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.2,
			cacheRead: 0.11,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 96000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-4.5-air": {
		id: "zai/glm-4.5-air",
		name: "GLM 4.5 Air",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.2,
			output: 1.1,
			cacheRead: 0.03,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 96000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-4.5v": {
		id: "zai/glm-4.5v",
		name: "GLM 4.5V",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.6,
			output: 1.8,
			cacheRead: 0.11,
			cacheWrite: 0,
		},
		contextWindow: 66000,
		maxTokens: 16000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-4.6": {
		id: "zai/glm-4.6",
		name: "GLM 4.6",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.2,
			cacheRead: 0.11,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 96000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-4.6v": {
		id: "zai/glm-4.6v",
		name: "GLM-4.6V",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.3,
			output: 0.9,
			cacheRead: 0.05,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 24000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-4.6v-flash": {
		id: "zai/glm-4.6v-flash",
		name: "GLM-4.6V-Flash",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 24000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-4.7": {
		id: "zai/glm-4.7",
		name: "GLM 4.7",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.2,
			cacheRead: 0.12,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 120000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-4.7-flash": {
		id: "zai/glm-4.7-flash",
		name: "GLM 4.7 Flash",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.07,
			output: 0.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 131000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-4.7-flashx": {
		id: "zai/glm-4.7-flashx",
		name: "GLM 4.7 FlashX",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.06,
			output: 0.4,
			cacheRead: 0.01,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-5": {
		id: "zai/glm-5",
		name: "GLM 5",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.95,
			output: 3.15,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 202800,
		maxTokens: 131100,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-5-turbo": {
		id: "zai/glm-5-turbo",
		name: "GLM 5 Turbo",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.2,
			output: 4,
			cacheRead: 0.24,
			cacheWrite: 0,
		},
		contextWindow: 202800,
		maxTokens: 131100,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-5.1": {
		id: "zai/glm-5.1",
		name: "GLM 5.1",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.3,
			output: 4.3,
			cacheRead: 0.26,
			cacheWrite: 0,
		},
		contextWindow: 202000,
		maxTokens: 202000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-5.2": {
		id: "zai/glm-5.2",
		name: "GLM 5.2",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.4,
			output: 4.4,
			cacheRead: 0.26,
			cacheWrite: 0,
		},
		contextWindow: 1040000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-5.2-fast": {
		id: "zai/glm-5.2-fast",
		name: "GLM 5.2 Fast",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 2.1,
			output: 6.6,
			cacheRead: 0.21,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"zai/glm-5v-turbo": {
		id: "zai/glm-5v-turbo",
		name: "GLM 5V Turbo",
		api: "anthropic-messages",
		provider: "vercel-ai-gateway",
		baseUrl: "https://ai-gateway.vercel.sh",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.2,
			output: 4,
			cacheRead: 0.24,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
} as const;
